//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
import { VAutocomplete } from 'vuetify/lib';
import { NsIcon } from '@nuskin/ns-icon';

import { PropsMixin, RulesMixin, ModelMixin } from '../mixins';

export default {
  name: 'DfAutocompleteField',
  components: {
    NsIcon,
    VAutocomplete,
  },
  mixins: [PropsMixin, RulesMixin, ModelMixin({ deep: true })],
  props: {
    /**
     * Field value
     * @type {Object}
     */
    value: {
      type: String,
      default: '',
    },
  },
};
